// Healthcare Technician Salary Search Module
import TomSelect from 'tom-select';

const MOBILE_BREAKPOINT = 768;
const KEYBOARD_HEIGHT_RATIO = 0.4;
const MIN_DROPDOWN_TOP = 20;
const DROPDOWN_RENDER_DELAY = 100;

const HealthcareSalarySearch = {
  init() {
    this.initializeSelect();
    this.bindSearchButton();
  },

  initializeSelect() {
    const jobTypeSelect = new TomSelect('#tech_job_description_slug', {
      sortField: {
        field: 'text',
        direction: 'asc',
      },
    });
    jobTypeSelect.on('dropdown_close', jobTypeSelect.blur);
    jobTypeSelect.on('dropdown_open', this.bindSelectFocusHandlers);
    jobTypeSelect.on('change', () => {
      this.toggleJobDescriptionError(false);
    });

    const locationSelect = new TomSelect('#bls_area_slug', {
      sortField: {
        field: 'text',
        direction: 'asc',
      },
    });
    locationSelect.on('dropdown_close', locationSelect.blur);
    locationSelect.on('dropdown_open', this.bindSelectFocusHandlers);
  },

  bindSelectFocusHandlers() {
    const isMobile = () =>
      window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;

    if (!isMobile()) return;

    setTimeout(() => {
      const dropdown = document.querySelector(
        '.ts-dropdown:not([style*="display: none"])'
      );
      if (!dropdown) return;
      const dropdownRect = dropdown.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const availableHeight = viewportHeight * (1 - KEYBOARD_HEIGHT_RATIO);

      const targetTop = Math.max(
        availableHeight - dropdownRect.height,
        MIN_DROPDOWN_TOP
      );

      const scrollAmount = dropdownRect.top - targetTop;

      if (
        scrollAmount > 0 ||
        targetTop + dropdownRect.height > availableHeight
      ) {
        window.scrollBy({
          top: scrollAmount,
          behavior: 'smooth',
        });
      }
    }, DROPDOWN_RENDER_DELAY);
  },

  bindSearchButton() {
    const searchButton = document.getElementById('search_salaries_btn');

    if (searchButton) {
      searchButton.addEventListener('click', () => {
        const techJobSlug = document.getElementById(
          'tech_job_description_slug'
        ).value;
        const blsAreaSlug = document.getElementById('bls_area_slug').value;

        // Require at least job type selection
        if (!techJobSlug) {
          this.toggleJobDescriptionError(true);
          return;
        }
        this.toggleJobDescriptionError(false);

        let url = `/salaries/healthcare-technician/${techJobSlug}`;

        // Add location if selected and not United States (national)
        if (blsAreaSlug && blsAreaSlug !== 'united-states') {
          url += `/${blsAreaSlug}`;
        }

        window.location.href = url;
      });
    }
  },

  toggleJobDescriptionError(show = true) {
    const errorElement = document.getElementById('job-description-error');
    if (errorElement) {
      errorElement.style.display = show ? 'block' : 'none';
    }
  },
};

export default HealthcareSalarySearch;
